import { render, staticRenderFns } from "./FullView2021.vue?vue&type=template&id=3a0f36e7"
import script from "./FullView2021.vue?vue&type=script&lang=js"
export * from "./FullView2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports